<div class="mt-4 mb-4 ms-3">
  <div class="d-flex gap-2 align-items-center">
    <button
      [disabled]="loading"
      (click)="loadData()"
      class="btn btn-default ms-2"
      container="body"
    >
      <i class="tio-refresh"></i> Refresh
    </button>

    <button
      [disabled]="loading"
      (click)="navigateToQBO()"
      class="btn btn-default ms-2"
      container="body"
      tooltip="Navigate to quickbooks"
    >
      <i class="tio-external-link"></i> View in quickbooks
    </button>
    <button
      #aiAnalysis
      [disabled]="loading || hasAiAnalysis"
      (click)="runAiAnalisys()"
      class="btn btn-primary ms-2"
      container="body"
      tooltip="Navigate to quickbooks"
    >
      <i class="tio-external-link"></i> Run AI Analysis
    </button>
  </div>
</div>

<div class="container-fluid" [ngClass]="{ 'component-loading': loading }">
  <table class="report-table">
    <thead>
      <tr class="subhead">
        <th>{{ data?.transactions?.columns[0] }}</th>
        <th>
          {{
            data?.transactions?.header?.StartPeriod
              | amParse: "YYYY-MM-DD"
              | amFromUtc
              | amDateFormat: "MMM Do, YYYY"
          }}
        </th>
        <th>
          {{
            data?.transactions?.header?.EndPeriod
              | amParse: "YYYY-MM-DD"
              | amFromUtc
              | amDateFormat: "MMM Do, YYYY"
          }}
        </th>
        <th>%</th>
        <th colspan="2">Actions</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let group of data?.transactions?.rows">
        <tr>
          <th colspan="4" class="main-heading">{{ group?.account }}</th>
        </tr>
        <ng-container *ngFor="let row of group?.rows">
          <ng-container
            *ngTemplateOutlet="recursiveRow; context: { row: row, indent: 0 }"
          ></ng-container>
        </ng-container>
        <tr
          class="grand-total"
          *ngIf="group?.summary"
          [ngClass]="{
            'review-highlight': group?.summary?.ai_review,
            reviewed:
              hasAiAnalysis &&
              (!row?.ai_review || row?.reviewed) &&
              rowHasValues(row),
          }"
          [popover]="group?.summary?.ai_review || null"
          triggers="mouseenter:mouseleave"
        >
          <td>
            <ng-container *ngIf="group?.summary?.ai_review">
              <i class="tio tio-warning"></i>
            </ng-container>
            {{ group?.summary?.account }}
          </td>
          <td class="value">{{ group?.summary?.previous_total }}</td>
          <td class="value">{{ group?.summary?.current_total }}</td>
          <td class="value">
            {{
              group?.summary?.previous_total && group?.summary?.current_total
                ? group?.summary?.percentage_value
                : ""
            }}
          </td>
          <td colspan="1"></td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<ng-template #recursiveRow let-row="row" let-indent="indent">
  <tr
    [ngClass]="{
      'section-heading': row?.type === 'Section',
      'data-row': row?.type === 'Data',
      clickable: row?.report_id,
      'review-highlight': row?.ai_review,
      reviewed:
        hasAiAnalysis &&
        (!row?.ai_review || row?.reviewed) &&
        rowHasValues(row),
    }"
    (click)="row?.report_id ? getReportDetails(row?.report_id) : null"
    [popover]="row?.ai_review || null"
    triggers="mouseenter:mouseleave"
  >
    <td [style.padding-left.px]="indent * 20">
      <ng-container *ngIf="row?.ai_review">
        <i class="tio tio-warning"></i>
      </ng-container>
      {{ row.report_id ? "*" : null }} {{ row?.account }}
    </td>
    <td class="value">{{ row?.previous_total }}</td>
    <td class="value">{{ row?.current_total }}</td>
    <td class="value">
      {{
        row?.previous_total && row?.current_total ? row?.percentage_value : ""
      }}
    </td>
    @if (row?.ai_review && !row?.reviewed) {
      <td (click)="markAsReviewed($event, row)" class="mark-as-reviewed">
        <i class="tio-checkmark_square_outlined fs-5"></i>
        Mark as Reviewed
      </td>
    } @else if (row?.reviewed) {
      <td (click)="markAsReviewed($event, row)">Reviewed</td>
    } @else {
      <td colspan="1"></td>
    }
  </tr>

  <ng-container *ngIf="row?.rows">
    <ng-container *ngFor="let child of row?.rows">
      <ng-container
        *ngTemplateOutlet="
          recursiveRow;
          context: { row: child, indent: indent + 1 }
        "
      ></ng-container>
    </ng-container>
  </ng-container>

  <tr
    *ngIf="indent === 0 && row?.summary"
    class="subtotal"
    [popover]="row?.summary?.ai_review || null"
    triggers="mouseenter:mouseleave"
  >
    <td [style.padding-left.px]="(indent + 1) * 20">
      <ng-container *ngIf="row?.summary?.ai_review">
        <i class="tio tio-warning"></i>
      </ng-container>
      {{ row?.summary?.account }}
    </td>
    <td class="value">{{ row?.summary?.previous_total }}</td>
    <td class="value">{{ row?.summary?.current_total }}</td>
    <td class="value">
      {{
        row?.summary?.previous_total && row?.summary?.current_total
          ? row?.summary?.percentage_value
          : ""
      }}
    </td>
    <td colspan="1"></td>
  </tr>
</ng-template>
